module.exports = __webpack_public_path__ + "img/调皮.ca8dc24a.png";